export function getFactNumbers(numberPart) {
  const [main, unit] = [...numberPart.children];

  return {
    factMain: main?.textContent?.trim() || '',
    factUnit: unit?.textContent?.trim() || '',
  };
}
